
import { Component, Vue } from 'vue-property-decorator';
import PageContainer from '@/components/PageTemplate/PageContainer.vue';
import PageTableOfContents from '@/components/PageTemplate/PageTableOfContents.vue';

@Component({
  components: {
    PageContainer,
    PageTableOfContents,
  },
})
export default class Scenarios extends Vue {
  get scenarioLinks() {
    return [
      {
        sectionName: this.$t('context.scenarioPage.sectionTitles.1'),
        sections: [
          {
            name: this.$t(
              'context.scenarioPage.pages.scenarioPlanning.pageName',
            ),
            routeName: 'ContextScenarioPlanning',
          },
        ],
      },
      {
        sectionName: this.$t('context.scenarioPage.sectionTitles.2'),
        sections: [
          {
            name: this.$t('context.scenarioPage.pages.baseline.pageName'),
            routeName: 'ContextScenarioBaseline',
          },
          {
            name: this.$t('context.scenarioPage.pages.scenarioA.pageName'),
            routeName: 'ContextScenarioA',
          },
          {
            name: this.$t('context.scenarioPage.pages.scenarioB.pageName'),
            routeName: 'ContextScenarioB',
          },
          {
            name: this.$t('context.scenarioPage.pages.scenarioC.pageName'),
            routeName: 'ContextScenarioC',
          },
          {
            name: this.$t('context.scenarioPage.pages.scenarioD.pageName'),
            routeName: 'ContextScenarioD',
          },
          {
            name: this.$t('context.scenarioPage.pages.scenarioE.pageName'),
            routeName: 'ContextScenarioE',
          },
        ],
      },
    ];
  }
}
